import {
    RaikoBaseCardContainer, RaikoCustomSelect, raikoCustomSelectItemGenerator,
    RaikoGridThreeColumn, RaikoNumberInputOutlined,
    RaikoSectionContainer, showServerErrorMessage, showSuccessMessage
} from "@moeindal/base-raiko-panel-components";
import {useEffect, useState} from "react";
import {PlayModeTypes} from "../../../pages/games/PlayModeTypes";
import {GameService} from "../../../serverService/gameService/GameService";
import {ServerErrorHandler} from "../../../service/errorHandler/ServerErrorHandler";

export default function GameSettings({gameId}) {

    const [playMode, setPlayMode] = useState(PlayModeTypes.MULTI.id);
    const [minTeamSize, setMinTeamSize] = useState(0);
    const [maxTeamSize, setMaxTeamSize] = useState(0);

    const service = new GameService()
    useEffect(() => {
        if (typeof service !== 'undefined') {
            getGameSettingsFromServer()
        }
    }, []);

    function getGameSettingsFromServer() {
        service.getGameSettings(gameId)
            .then(response => {
                setPlayMode(response.playMode === PlayModeTypes.SINGLE.title ?
                    PlayModeTypes.SINGLE.id : PlayModeTypes.MULTI.id)
                setMinTeamSize(response.minTeamSize)
                setMaxTeamSize(response.maxTeamSize)
            }).catch(reason => {
            showServerErrorMessage(new ServerErrorHandler(reason).getMessage())
        })
    }
    
    function handleUpdateGameSettings() {
        service.updateGameSettings(gameId,playMode)
            .then(response=>{
                showSuccessMessage("بروزرسانی با موفقیت انجام شد.")
            }).catch(reason => {
                showServerErrorMessage(new ServerErrorHandler(reason).getMessage())
        })
    }


    return (
        <RaikoBaseCardContainer>
            <RaikoSectionContainer
                title={"تنظیمات"}
                hasActionButton
                actionButtonOnclick={handleUpdateGameSettings}
            >
                {playMode === PlayModeTypes.MULTI.id ? <RaikoGridThreeColumn>
                    <RaikoCustomSelect
                        labelText={"نوع بازی"}
                        value={playMode}
                        setValue={setPlayMode}
                        items={[
                            raikoCustomSelectItemGenerator(PlayModeTypes.SINGLE.id, PlayModeTypes.SINGLE.title),
                            raikoCustomSelectItemGenerator(PlayModeTypes.MULTI.id, PlayModeTypes.MULTI.title),
                        ]}
                    />
                    <RaikoNumberInputOutlined labelText={"حداقل تعداد افراد تیم"} value={minTeamSize}
                                              setValue={setMinTeamSize}/>
                    <RaikoNumberInputOutlined labelText={"حداکثر تعداد افراد تیم"} value={maxTeamSize}
                                              setValue={setMaxTeamSize}/>

                </RaikoGridThreeColumn> : <RaikoGridThreeColumn>
                    <RaikoCustomSelect
                        labelText={"نوع بازی"}
                        value={playMode}
                        setValue={setPlayMode}
                        items={[
                            raikoCustomSelectItemGenerator(PlayModeTypes.SINGLE.id, PlayModeTypes.SINGLE.title),
                            raikoCustomSelectItemGenerator(PlayModeTypes.MULTI.id, PlayModeTypes.MULTI.title),
                        ]}
                    />
                </RaikoGridThreeColumn>}

            </RaikoSectionContainer>
        </RaikoBaseCardContainer>
    )
}